import { Component, Input, OnInit } from '@angular/core';
import { GridRegistrationModel } from '@bo-client/activation-management/grid-registration/model/grid-registration.model';
import {
  NaProtectionTypeEnum,
  SymmetryConditionsEnum
} from '@bo-client/activation-management/grid-registration/model/grid-registration.enum';
import { ConsumerModel } from '@bo-client/activation-management/grid-registration/model/consumer.model';
import { PowerInverterTypeDisplayNames } from '@bo-client/activation-management/grid-registration/model/producer.model';
import { storageTotal } from '@bo-client/activation-management/grid-registration/storage-totals.util';
import { MetaService } from '@bo-client/core/api/meta-service';
import { map, shareReplay, takeUntil } from 'rxjs/operators';
import { of, Subject } from 'rxjs';
import { DataShareService } from '@bo-client/shared/services/data-share.service';

@Component({
  selector: 'app-gr-place-in-service-storage-summary',
  templateUrl: './gr-place-in-service-storage-summary.component.html',
  styleUrls: ['../../../../shared/summaries/css-summary.component.scss']
})
export class GrPlaceInServiceStorageSummaryComponent implements OnInit {
  @Input() gr: GridRegistrationModel;

  protected totalActivePower = 0;
  protected totalApparentPower = 0;
  protected totalModulePower = 0;

  protected naProtectionTypeEnum = NaProtectionTypeEnum;
  protected symmetryConditionsEnum = SymmetryConditionsEnum;
  protected readonly powerInverterTypeDisplayNames = PowerInverterTypeDisplayNames;

  /**
   * Der Speicher des v2-Prozesses verteilt sich über drei Sammlungen: `storages[0]` trägt die
   * Speicherdaten, `producers[]` die Wechselrichter (der erste zusätzlich die Entladeleistung) und
   * `consumers[0]` den Speicher als Verbrauchseinrichtung (Lade- und Wechselrichterleistung, §14a).
   */
  protected get firstConsumer(): ConsumerModel | undefined {
    return this.gr.consumers?.[0];
  }

  protected get dischargePower(): number | undefined {
    return this.gr.producers?.[0]?.dischargePower;
  }

  /** Anzahl der Speichersysteme; alle Einzelwerte gelten pro System. */
  protected get storageCount(): number | undefined {
    return this.gr.storages?.[0]?.count;
  }

  /** Gesamtwert eines Speicher-Einzelwerts (`Anzahl × Einzelwert`), `null` bei fehlender Angabe. */
  protected total(valuePerStorage: unknown): number | null {
    return storageTotal(this.storageCount, valuePerStorage);
  }

  showExternalIdField$ = of(false);
  showExternalCustomerIdField$ = of(false);

  private ngUnsubscribe$ = new Subject<void>();

  get hasMeterValues() {
    return this.gr.meterNumber && this.gr.meterOne?.value;
  }

  constructor(protected metaService: MetaService, private dataShareService: DataShareService) {
    // Empty
  }

  ngOnInit(): void {
    this.initShowExternalIdFields();
    // Gesamtwerte über alle Wechselrichter (Anzahl × Einzelwert je Gerät).
    if (this.gr.producers && this.gr.producers.length > 0) {
      this.gr.producers.forEach((x) => {
        this.totalActivePower = this.totalActivePower + x.acActivePowerMax * x.count;
        this.totalApparentPower = this.totalApparentPower + x.acApparentPowerMax * x.count;
      });
    }
  }

  private initShowExternalIdFields() {
    const config$ = this.dataShareService.tenantConfig$.pipe(
      takeUntil(this.ngUnsubscribe$),
      map((config) => config?.gridRegistration),
      shareReplay(1)
    );
    this.showExternalIdField$ = config$.pipe(map((config) => !!config?.showExternalIdField));
    this.showExternalCustomerIdField$ = config$.pipe(map((config) => !!config?.showExternalCustomerIdField));
  }
}
